export const LISTENING_STATE = {
  NOT_STARTED: 'not-started',
  LISTENING: 'listening',
  STOPPED: 'stopped',
};

export type ListeningStateModel = typeof LISTENING_STATE[keyof typeof LISTENING_STATE];
